<template>
  <div class="mt-3">
    <b-overlay :show="loading">
      <b-form @submit.stop.prevent="sendNotification">
        <b-form-group label="Title">
          <b-form-input  name="title" v-model="fdata.title" v-validate="{ required: true, min: 3 }" :state="validateState('title')" aria-describedby="title-feedback" data-vv-as="Title"></b-form-input>
          <b-form-invalid-feedback id="title-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Body">
          <b-form-textarea class="mb-2" v-model="fdata.body" v-validate="{ required: true, min: 3 }" :state="validateState('body')" aria-describedby="body-feedback" data-vv-as="Body"></b-form-textarea>
          <b-form-invalid-feedback id="body-feedback">{{ veeErrors.first('body') }}</b-form-invalid-feedback>
        </b-form-group>
        <b-button type="submit">Send Notification</b-button>
      </b-form>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props:['all'],
  data(){
    return {
      loading: false,
      employees: [],
      fdata: {
        title: '',
        body:'',
      }
    };
  },
  methods:{
    sendNotification()
    {
      let formData = new FormData();
      for(const [k,v] of Object.entries(this.fdata)){
        formData.append(k, v);
      }
      formData.append('channel', this.$api_url);
      formData.append('all', this.all);

      this.loading = true;

      axios.post(this.$api_url + '/notification/send/all', formData).then(response => {
        this.$bvToast.toast(
            'Successfully sent',{
              solid: true,
              variant: 'success',
              title: "Success"
            }
        );

        this.loading = false;  
      }).catch(e => {
        this.loading = false;  
      });
    },
  },
  created(){
    this.getEmployees();
  }
}
</script>

<style scoped>

</style>